import { useState, useEffect, useRef } from "react";
import NiceModal from '@ebay/nice-modal-react';
import ApiModal from '/src/components/modal/ApiModal/ApiModal';

import "./DashboardBlock.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import DashboardVariable from "../../variable/DashboardVariable/DashboardVariable";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import dashboardService from '../../../services/dashboardService';
import { isClient, isAdmin } from "/src/utils/access";
import DashboardFormBlockModal from '../DashboardFormBlockModal/DashboardFormBlockModal';
import DashboardVariableFormModal from '../../variable/DashboardVariableFormModal/DashboardVariableFormModal'
import DashboardEditorGrid from "../../grid/DashboardEditorGrid/DashboardEditorGrid";
import { useAnimationBlock, getBlockParameterById } from "../../../hooks/useAnimationBlock";
function DashboardBlock({ data, bot, modifyBlockAction, arrowPointedAdd, access, index }) {
    const [block, setBlock] = useState(data);
    const { animationBlock, rotateChevron, openBlock } = useAnimationBlock(block);
    const [showRemove, setShowRemove] = useState(getBlockParameterById(block.id));
    const { updatePositionBlock, deleteBlock } = dashboardService;
    const toast = useToastDispatchContext();
    const refBlockContainer = useRef(null);
    var listVariableDashboard = block.dashboard.blocks.filter(block => block.type == 0).map(block => block.variables).flat().sort(function (a, b) {
        return (a.position === null) - (b.position === null) || +(a.position > b.position) || -(a.position < b.position);
    });
    var variables = block.variables.sort(function (a, b) {
        return (a.position === null) - (b.position === null) || +(a.position > b.position) || -(a.position < b.position);
    });

    var structure = block.type == 1 ? JSON.parse(block.grid.structure) : ""
    const rotate = rotateChevron ? "close_style" : "open_style"
    const showEditBlockModal = () => NiceModal.show(DashboardFormBlockModal, {
        dashboardChannel: block.dashboard_channel,
        block: block,
        setBlock: modifyBlockAction,
        bot: bot,
    });
    const showAddVariableModal = () => NiceModal.show(DashboardVariableFormModal, {
        block_id: block.id,
        postbackAction: modifyBlockAction,
        bot: bot,
        dashboardChannel: block.dashboard_channel,
    });
    const showRemoveBlockModal = async () => {
        await NiceModal.show(ApiModal, {
            title: "Delete Block",
            body: "Do you really want to delete the block : \" " + block.name + " \" ?",

            api: {
                request: deleteBlock,
                param: [block.id]
            },

            buttons: [
                { className: 'validate', label: 'Cancel' },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ],
            confirm: {
                name: block.name,
                fieldName: "this block",
            }
        });
        toast.success("Block removed", 'The block ' + block.name + " has been removed ! ");
        modifyBlockAction();

    };

    const getStyleVariable = (i) => {
        let res = "";
        if (i + 1 != variables.length) {// not last row
            res += "separator_dashboard_variable "
        } // i == 0 : 1st row, i == variables.length-1 : last row
        return res;
    }

    const checkValueVariable = (_variable, _block) => {
        let shared_values = _block.shared_values_variables ? JSON.parse(_block.shared_values_variables) : null;
        if (shared_values == null) return _variable.value;
        const value = shared_values.find(val => val.dashboard_variable_id === _variable.id).value;
        return value;
    }

    useEffect(() => {
        if (block != null) {
            setBlock(data)
        }
    })

    const checkCondition = (variable) => {
        if (variable.conditions.length == 0) return true;
        let cpt = 0;
        let _block = block.dashboard.blocks.find(b => b.id === variable.dashboard_block_id);
        // on regroupe chaque block de condtions par index
        let blocksConds = [];
        variable.conditions.forEach(condition => {
            if (blocksConds[condition.block_index] == null) {
                blocksConds[condition.block_index] = [];
            }
            blocksConds[condition.block_index].push(condition);
        })
        blocksConds.forEach(blockCondition => {
            cpt = checkSingleBlock(blockCondition, _block) ? cpt + 1 : cpt - 1
        })

        return cpt == blocksConds.length;

    }

    const modifyPositionBlock = async (pos) => {
        if (pos < 0 || pos >= index.max) return;
        let dataToSend = { "position": pos }
        const [response, errors] = await updatePositionBlock(block.id, dataToSend)
        if (errors != null) {
            console.log(errors)
            return;
        }
        //modal.resolve(response);
        //toast.success('Variable\'s position changed', 'The position of the variable " ' + response.label + ' " has been changed !');
        modifyBlockAction();
    }
    const checkSingleBlock = (blockCondition, _block) => {
        let cpt = 0;
        blockCondition.forEach((cond) => {
            let variableCheck = listVariableDashboard.find(v => v.id === cond.variable_target_id); // recuperer la valeur de la variable actuelle, dashbaord partagee 
            if (checkValueVariable(variableCheck, _block) == cond.value) cpt++;
        })
        return cpt > 0; // si 0 signifie que toutes les conditions sont fausse, donc le ou renvoie aucune bonne valeur
    }
    useEffect(() => {
        if (block.position == null) {
            modifyPositionBlock(index.current);
        }
    }, [])
    return (
        <div onMouseOut={() => { setShowRemove(false) }} onMouseOver={() => { setShowRemove(true) }}>
            <div className="dashboard_title_mainBlock">
                <div className="block_title">
                    <div>
                        <div className={"position_block_container " + (block.position == index.max - 1 || block.position == 0 ? "position_arrow_dropdown" : "")}>
                            {
                                showRemove == true && isAdmin(access) && block.origin != 0 &&
                                <>
                                    {
                                        block.position != 0 &&
                                        <i className="fas fa-chevron-up" style={{ cursor: "pointer", marginBottom: block.position != index.max - 1 ? "15px" : "" }} aria-hidden="true" onClick={() => modifyPositionBlock(block.position - 1)} />
                                    }
                                    {
                                        block.position != index.max - 1 &&
                                        <i className="fas fa-chevron-down" style={{ cursor: "pointer" }} aria-hidden="true" onClick={() => modifyPositionBlock(block.position + 1)} />
                                    }
                                </>
                            }
                        </div>
                    </div>
                    <IconButton onClick={() => { openBlock() }} className="main-iconButton profil_action main_add-button space_tableButton dashboard_button" icon={"fas fa-chevron-right " + rotate} key={'buttonOpen-' + block.id} />
                    <div className="dashboard_title" onClick={() => { openBlock() }}>{block.name}</div>
                    {!isClient(access) && showRemove == true &&
                        <>
                            <IconButton onClick={() => showEditBlockModal()} className="main-iconButton profil_action main_add-button space_tableButton dashboard_button" icon="fas fa-pencil-alt" key={'buttonEdit-' + block.id} />

                            <IconButton onClick={() => showRemoveBlockModal()} className="main-iconButton remove-hover modalButtons-input delete_action red-button-action-bg_color dashboard_button" icon="fas fa-trash" key={'buttonRemove-' + block.id} />

                        </>
                    }

                </div>
                {
                    !isClient(access) &&
                    < div style={{ display: 'flex' }}>
                        {
                            arrowPointedAdd == true &&
                            <div className="arrow_right bounce">
                                <a className="fa fa-arrow-right fa-2x"></a>
                            </div>
                        }
                        {
                            block.type != 1 &&
                            <IconButton className="main-iconButton profil_action main_add-button space_tableButton dashboard_button" icon="fas fa-plus" key={'buttonAdd-' + block.id} onClick={() => showAddVariableModal()} />
                        }
                    </div>
                }
            </div>
            { // BLOCK SIMPLE
                block.type == 0 && variables != null &&

                < div ref={refBlockContainer} className={variables.length > 0 ? ("dashboard_block_container_variable :  " + animationBlock) : ""}>
                    {
                        variables != null && variables.map((variable, i) => {
                            variable.value = checkValueVariable(variable, block);
                            variable.origin = block.origin;
                            variable.printedInView = checkCondition(variable);
                            if (variable.printedInView == true || isAdmin(access)) {
                                return <DashboardVariable dashboard_channel={block.dashboard_channel} access={access} variable={variable} key={i} postbackAction={modifyBlockAction} bot={bot} className={getStyleVariable(i)} index={{ current: i, max: variables.length }} />
                            }
                        })
                    }
                </div>
            }
            { // GRID

                block.type == 1 && ((structure.rows && structure.rows.length > 0) || (structure.columns && structure.columns.length > 0)) &&

                <div ref={refBlockContainer} className={"dashboard_block_container_variable :  " + animationBlock}>
                    <DashboardEditorGrid data={block} structure={structure} postbackAction={modifyBlockAction} access={access}></DashboardEditorGrid>
                </div>

            }
        </div >
    );
}

export default DashboardBlock;